export default __webpack_public_path__ + "static/media/rstudio.a5ebf884.svg";